export enum Industry {
  AVIATION = 'aviation',
  EXPERIENCES_AND_TOURISM = 'experiences & tourism',
  HOSPITALITY = 'hospitality',
  LUXURY_VEHICLES = 'luxury vehicles',
  MEDIA_AND_ENTERTAINMENT = 'media & entertainment',
  OTHER = 'other',
  RETAIL_AND_FASHION = 'retail & fashion',
  REWARDS_PROGRAMS = 'rewards programs',
  WELLBEING_AND_BEAUTY = 'wellbeing & beauty',
  WINE_AND_SPIRITS = 'wine & spirits',
}

export enum BrandMarketingDescription {
  MAJOR_BRAND = 'major brand',
  LOCAL_BRANCH_OF_MAJOR_BRAND = 'local branch of major brand',
  LOCAL_BUSINESS = 'local business',
}

export enum BrandExperienceFrequency {
  ONGOING = 'ongoing',
  ONE_TIME = 'one-time',
  SEASONAL = 'seasonal',
}

export enum BrandExperienceTypes {
  ACCESS_PASSES = 'Access Passes',
  AMENITIES_AND_RENTALS = 'Amenities & Rentals',
  BRAND_ACTIVATIONS = 'Brand Activations',
  CLASSES_AND_WORKSHOPS = 'Classes & Workshops',
  GUIDED_ACTIVITIES = 'Guided Activities',
  LIVE_ENTERTAINMENT = 'Live Entertainment',
  SEASONAL_HOLIDAY = 'Seasonal / Holiday',
  TICKETED_EVENTS = 'Ticketed Events',
  WELLBEING = 'Wellbeing',
  NOT_CURRENTLY_OFFERING = 'Not currently offering',
  OTHER = 'Other',
}

export enum BrandReach {
  INTERNATIONAL = 'International',
  NATIONAL = 'National',
  REGIONAL = 'Regional',
  LOCAL = 'Local',
}
